module.exports = __webpack_public_path__ + "u8.no2.ce2a9d58.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/nakagawa/u8.no2.jpg
// module id = nLgH
// module chunks = 0